var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0957 14.6924V10.5578V10.5578C11.0957 7.51339 13.5641 5.04504 16.6085 5.04504V5.04504C19.6529 5.04504 22.1213 7.51339 22.1213 10.5578V10.5578V14.6924",
    stroke: "#828282",
    strokeWidth: 2.06729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6085 20.2052V24.3398",
    stroke: "#828282",
    strokeWidth: 2.06729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4993 29.8525H9.71733C8.19442 29.8525 6.96094 28.6191 6.96094 27.0962V17.4488C6.96094 15.9259 8.19442 14.6924 9.71733 14.6924H23.4993C25.0222 14.6924 26.2557 15.9259 26.2557 17.4488V27.0962C26.2557 28.6191 25.0222 29.8525 23.4993 29.8525Z",
    stroke: "#828282",
    strokeWidth: 2.06729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fbcc3d584009b38157335de63e9536ab.svg";
export { ForwardRef as ReactComponent };